(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aur-base"]) return;
  try {
    
  customElements.whenDefined('aur-teke-revelo').then(() => {
  class FooterMenu extends HTMLElement {
    constructor() {
      super();
      this.menus = this.querySelectorAll('aur-teke-revelo');
      this.resetHandler = this.reset.bind(this);
      setTimeout(this.resetHandler, 50);
    }

    connectedCallback() {
      window.addEventListener('on:breakpoint-change', this.resetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.resetHandler);
    }

    reset() {
      this.menus.forEach((menu) => {
        if (theme.mediaMatches.lg) {
          if (!menu.disclosure.open) {
            menu.open();
          }
          menu.toggle.setAttribute('tabindex', '-1');
        } else {
          if (menu.disclosure.open) {
            menu.close();
          }
          menu.toggle.removeAttribute('tabindex');
        }
      });
    }
  }

  customElements.define('aur-base-cardapio', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
